<template>
    <div class="layout-main-container">
        <div class="layout-main">
            <div id="controls" dir="rtl" v-if="requests.length > 0">
                <div>
                    <Button :label="$t('ACCEPT_BTN')" @click="acceptUsers" :disabled="!canAcceptUsers" />
                    <Button :label="$t('REJECT_BTN')" @click="denyUsers" :disabled="!canAcceptUsers" />
                </div>
            </div>
            <div class="flex flex-wrap justify-content-center" style="margin-top: 0.5em;">
                <div v-for="request in requests" :key="request" class="flex join_request">
                    <Card style="width: 180px; height: 280px; margin: 5px;direction: rtl;">
                        <template #title>
                            <Checkbox style="margin: 0.5em 0.5em 0 0;" v-model="request.selected" :binary="true"
                                @change="manageCheckEvent(request)" />
                            <div style="word-wrap: break-word; text-align: center;">
                                <font-awesome-icon :icon="['fas', 'user']" />
                                <div style="margin-top: 5px;">
                                    {{ request.email }}
                                </div>
                            </div>
                        </template>
                        <template #content>
                            <div class="text-center" style="font-weight: bold; font-size: 0.8rem">
                                <div style="height: 2.5em;margin-bottom: 0.5em;">
                                    <div>
                                        {{ $t('FIRST_NAME') }}:
                                    </div>
                                    <div>
                                        {{ request.firstName }}
                                    </div>
                                    <div>
                                        {{ $t('LAST_NAME') }}:
                                    </div>
                                    <div>
                                        {{ request.lastName }}
                                    </div>
                                    <div>
                                        {{ $t('USER_JOIN_REQUEST_DATE') }}:
                                    </div>
                                    <div>
                                        {{ utils.formatDate(request.requestDate) }}
                                    </div>
                                </div>
                            </div>
                        </template>
                    </Card>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onErrorCaptured, onBeforeMount, computed } from 'vue'
import { handleError } from '@/helpers/ErrorHandler'
import { useToast } from 'primevue/usetoast'
import { useAuthStore } from '@/stores/auth'
import { useI18n } from 'vue-i18n'
import userService from '@/service/UserService'
import remove from 'lodash/remove'
import utils from '@/helpers/Utils'

const authStore = useAuthStore()
const toast = useToast()
const i18n = useI18n()

const requests = ref([])
const selectedRequests = ref([])

onBeforeMount(async () => {
    try {
        const response = await userService.getPendingJoinRequests()
        requests.value = response.result.collection
    } catch (error) {
        handleError(authStore, toast, i18n, error)
    }
})

onErrorCaptured((err, instance, info) => {
    return handleError(authStore, toast, i18n, err, instance, info)
})

const canAcceptUsers = computed(() => {
    return selectedRequests.value.length > 0
})

const acceptUsers = async () => {
    if (selectedRequests.value.length > 0) {
        let response = await userService.acceptJoinRequests(selectedRequests.value.map(r => r.email))
        toast.add({ severity: 'info', summary: response.message, detail: '', life: 3000 })
        response = await userService.getPendingJoinRequests()
        requests.value = response.result.collection
    }
}

const denyUsers = async () => {
    if (selectedRequests.value.length > 0) {
        let response = await userService.denyJoinRequests(selectedRequests.value.map(r => r.email))
        toast.add({ severity: 'info', summary: response.message, detail: '', life: 3000 })
        response = await userService.getPendingJoinRequests()
        requests.value = response.result.collection
    }
}

// Events

const manageCheckEvent = (request) => {
    if (request.selected === true) {
        selectedRequests.value.push(requests.value.filter(r => r.email === request.email)[0])
    } else {
        remove(selectedRequests.value, r => r.email === request.email)
    }
}

</script>

<style scoped>
.join_request:deep(.p-card) {
    background: var(--blue-black-new-1);
    border-radius: 18px !important;
    border: 0.1px solid #e5e3d7 !important;
}

#controls>* {
    margin-bottom: 1em;
}

#controls:deep(.p-button) {
    margin-left: 0.5em;
}

.join_request:deep(.p-card-body) {    
    padding: 0.2rem;
}
</style>